import type { Feature } from 'geojson';
import { type TAPlan } from '../../TAPlan/TAPlan.types';
import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = () => ({
    id: 'taplan-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/taplan`,
    displayName: 'Avstängningar och omledningar',
});

export class TAPlanSource extends AjaxSource<AjaxSourceOptions> {
    constructor(options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions(), ...options });
    }

    parseData(plans: TAPlan[]): Feature[] {
        return plans.map((plan) => ({
            id: plan.id,
            type: 'Feature',
            geometry: plan.wgs84Position,
            properties: plan,
        }));
    }
}
